"use strict";

var _regeneratorRuntime = require("/app/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;

var _toConsumableArray = require("/app/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck.js").default;

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass.js").default;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var BottleneckError, DEFAULT_PRIORITY, Job, NUM_PRIORITIES, parser;
NUM_PRIORITIES = 10;
DEFAULT_PRIORITY = 5;
parser = require("./parser");
BottleneckError = require("./BottleneckError");

Job = /*#__PURE__*/function () {
  function Job(task, args, options, jobDefaults, rejectOnDrop, Events, _states, Promise) {
    var _this3 = this;

    _classCallCheck(this, Job);

    this.task = task;
    this.args = args;
    this.rejectOnDrop = rejectOnDrop;
    this.Events = Events;
    this._states = _states;
    this.Promise = Promise;
    this.options = parser.load(options, jobDefaults);
    this.options.priority = this._sanitizePriority(this.options.priority);

    if (this.options.id === jobDefaults.id) {
      this.options.id = "".concat(this.options.id, "-").concat(this._randomIndex());
    }

    this.promise = new this.Promise(function (_resolve, _reject) {
      _this3._resolve = _resolve;
      _this3._reject = _reject;
    });
    this.retryCount = 0;
  }

  _createClass(Job, [{
    key: "_sanitizePriority",
    value: function _sanitizePriority(priority) {
      var sProperty;
      sProperty = ~~priority !== priority ? DEFAULT_PRIORITY : priority;

      if (sProperty < 0) {
        return 0;
      } else if (sProperty > NUM_PRIORITIES - 1) {
        return NUM_PRIORITIES - 1;
      } else {
        return sProperty;
      }
    }
  }, {
    key: "_randomIndex",
    value: function _randomIndex() {
      return Math.random().toString(36).slice(2);
    }
  }, {
    key: "doDrop",
    value: function doDrop() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          error = _ref.error,
          _ref$message = _ref.message,
          message = _ref$message === void 0 ? "This job has been dropped by Bottleneck" : _ref$message;

      if (this._states.remove(this.options.id)) {
        if (this.rejectOnDrop) {
          this._reject(error != null ? error : new BottleneckError(message));
        }

        this.Events.trigger("dropped", {
          args: this.args,
          options: this.options,
          task: this.task,
          promise: this.promise
        });
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "_assertStatus",
    value: function _assertStatus(expected) {
      var status;
      status = this._states.jobStatus(this.options.id);

      if (!(status === expected || expected === "DONE" && status === null)) {
        throw new BottleneckError("Invalid job status ".concat(status, ", expected ").concat(expected, ". Please open an issue at https://github.com/SGrondin/bottleneck/issues"));
      }
    }
  }, {
    key: "doReceive",
    value: function doReceive() {
      this._states.start(this.options.id);

      return this.Events.trigger("received", {
        args: this.args,
        options: this.options
      });
    }
  }, {
    key: "doQueue",
    value: function doQueue(reachedHWM, blocked) {
      this._assertStatus("RECEIVED");

      this._states.next(this.options.id);

      return this.Events.trigger("queued", {
        args: this.args,
        options: this.options,
        reachedHWM: reachedHWM,
        blocked: blocked
      });
    }
  }, {
    key: "doRun",
    value: function doRun() {
      if (this.retryCount === 0) {
        this._assertStatus("QUEUED");

        this._states.next(this.options.id);
      } else {
        this._assertStatus("EXECUTING");
      }

      return this.Events.trigger("scheduled", {
        args: this.args,
        options: this.options
      });
    }
  }, {
    key: "doExecute",
    value: function doExecute(chained, clearGlobalState, run, free) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var error, eventInfo, passed;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.retryCount === 0) {
                  _this._assertStatus("RUNNING");

                  _this._states.next(_this.options.id);
                } else {
                  _this._assertStatus("EXECUTING");
                }

                eventInfo = {
                  args: _this.args,
                  options: _this.options,
                  retryCount: _this.retryCount
                };

                _this.Events.trigger("executing", eventInfo);

                _context.prev = 3;
                _context.next = 6;
                return chained != null ? chained.schedule.apply(chained, [_this.options, _this.task].concat(_toConsumableArray(_this.args))) : _this.task.apply(_this, _toConsumableArray(_this.args));

              case 6:
                passed = _context.sent;

                if (!clearGlobalState()) {
                  _context.next = 13;
                  break;
                }

                _this.doDone(eventInfo);

                _context.next = 11;
                return free(_this.options, eventInfo);

              case 11:
                _this._assertStatus("DONE");

                return _context.abrupt("return", _this._resolve(passed));

              case 13:
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](3);
                error = _context.t0;
                return _context.abrupt("return", _this._onFailure(error, eventInfo, clearGlobalState, run, free));

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 15]]);
      }))();
    }
  }, {
    key: "doExpire",
    value: function doExpire(clearGlobalState, run, free) {
      var error, eventInfo;

      if (this._states.jobStatus(this.options.id === "RUNNING")) {
        this._states.next(this.options.id);
      }

      this._assertStatus("EXECUTING");

      eventInfo = {
        args: this.args,
        options: this.options,
        retryCount: this.retryCount
      };
      error = new BottleneckError("This job timed out after ".concat(this.options.expiration, " ms."));
      return this._onFailure(error, eventInfo, clearGlobalState, run, free);
    }
  }, {
    key: "_onFailure",
    value: function _onFailure(error, eventInfo, clearGlobalState, run, free) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var retry, retryAfter;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!clearGlobalState()) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 3;
                return _this2.Events.trigger("failed", error, eventInfo);

              case 3:
                retry = _context2.sent;

                if (!(retry != null)) {
                  _context2.next = 11;
                  break;
                }

                retryAfter = ~~retry;

                _this2.Events.trigger("retry", "Retrying ".concat(_this2.options.id, " after ").concat(retryAfter, " ms"), eventInfo);

                _this2.retryCount++;
                return _context2.abrupt("return", run(retryAfter));

              case 11:
                _this2.doDone(eventInfo);

                _context2.next = 14;
                return free(_this2.options, eventInfo);

              case 14:
                _this2._assertStatus("DONE");

                return _context2.abrupt("return", _this2._reject(error));

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }, {
    key: "doDone",
    value: function doDone(eventInfo) {
      this._assertStatus("EXECUTING");

      this._states.next(this.options.id);

      return this.Events.trigger("done", eventInfo);
    }
  }]);

  return Job;
}();

module.exports = Job;